import { colors } from '@kmns-internal/furikake'
import { Check, RefreshOutlined, Warning } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { ReportExportStatusEnum } from '@ulysses-inc/harami_api_client'
import invariant from 'tiny-invariant'

type Props = {
  status: ReportExportStatusEnum
  isPartial?: boolean
}

// Jestではsvgをインポートできず、ReactComponentがundefinedになるため、スタブに差し替える
const StubIconForTesting = () => <div></div>

export const StatusIcon = ({ status, isPartial = false }: Props) => {
  const settings = {
    [ReportExportStatusEnum.PROCESSING]: {
      Icon: RefreshOutlined || StubIconForTesting,
      text: '出力中',
      iconColor: colors.warning.main,
    },
    [ReportExportStatusEnum.COMPLETED]: isPartial
      ? {
          Icon: Warning || StubIconForTesting,
          text: '一部完了',
          iconColor: colors.warning.main,
        }
      : {
          Icon: Check || StubIconForTesting,
          text: '完了',
          iconColor: colors.success.main,
        },
    [ReportExportStatusEnum.FAILED]: {
      Icon: Warning || StubIconForTesting,
      text: '出力失敗',
      iconColor: colors.error.main,
    },
  } as const

  invariant(settings[status], 'レポート出力結果のステータスが不正です')

  const { Icon, text, iconColor } = settings[status]
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Icon sx={{ color: iconColor }} />
      <Typography variant="body2">{text}</Typography>
    </Stack>
  )
}
